export function getFormatKey(format: {w: number; h: number}) {
  if (!format?.w || !format?.h) return '';

  return `${format?.w}x${format?.h}`;
}
